// import React, { useRef, useState } from "react";
// import { Tab, Tabs } from "react-bootstrap";
// import LoadingSpinner from "../../../components/loader/LoadingSpinner";
// import Timesheet from "../../../components/report/Timesheet";
// import "./Report.css";
// import Sales from "../../../components/report/Sales";
// import { MenuItem, Typography } from "@mui/material";
// import { useSearchParams } from "react-router-dom";
// import Select from "react-select";
// import Report_View from "./Report_View";

// function Report() {
//   const [loading, setLoading] = useState(false);
//   const [selectedValue, setSelectedValue] = useState(null);

//   const data = [
//     { value: "user1", label: "User1" },
//     { value: "user2", label: "User2" },
//     { value: "user3", label: "User3" },
//   ];

//   return loading ? (
//     <LoadingSpinner />
//   ) : (
//     <div className="report-section">
//       <div className="report-subsection">
//         {/* <div className="text-xl font-semibold">User Report</div> */}
//         {/* <div className="mt-5">
//           <Select
//             name="user"
//             className="max-w-[250px]"
//             classNamePrefix="select"
//             isClearable={true}
//             placeholder={"Select a User"}
//             isSearchable={true}
//             options={data}
//             onChange={(selectedOptions) => setSelectedValue(selectedOptions)}
//           />
//           <div className="mt-5">{selectedValue && <Report_View/>}</div>
//         </div> */}
//       </div>
//     </div>
//   );
// }

// export default Report;

import React, { useState } from "react";
import Repotemployeetask from "./Repotemployeetask";
import Repotemployeehours from "./Repotemployeehours";
import Repotemployeecompletedtask from "./Repotemployeecompletedtask";
import Repotemployeedetailstask from "./Repotemployeedetailstask";

const Report = () => {
  const [activeTab, setActiveTab] = useState("take_action");

  const handleTabChange = (e) => {
    setActiveTab(e.target.name);
  };

  return (
    <div className="h-full flex flex-col rounded-lg p-4 bg-[#fff]">
      <ul className="nav nav-pills mb-3 mt-2" id="pills-tab" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${
              activeTab === "take_action" ? "active" : ""
            }`}
            id="pills-take_action-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-take_action"
            type="button"
            role="tab"
            aria-controls="pills-take_action"
            aria-selected="true"
            onClick={(e) => handleTabChange(e)}
            name="take_action"
          >
            Task Report
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === "archive" ? "active" : ""}`}
            id="pills-archive-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-archive"
            type="button"
            role="tab"
            aria-controls="pills-archive"
            aria-selected="true"
            onClick={(e) => handleTabChange(e)}
            name="archive"
          >
            Tracker Report
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === "completed" ? "active" : ""}`}
            id="pills-completed-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-completed"
            type="button"
            role="tab"
            aria-controls="pills-completed"
            aria-selected="true"
            onClick={(e) => handleTabChange(e)}
            name="completed"
          >
            Completed Task
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            id="pills-details-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-details"
            type="button"
            role="tab"
            aria-controls="pills-details"
            aria-selected="true"
            onClick={(e) => handleTabChange(e)}
            name="details"
          >
            Pending Task Report
          </button>
        </li>
      </ul>
      <div className="grow overflow-y-auto program_scroll">
        <div className="h-full tab-content" id="pills-tabContent">
          <div
            className={`h-full tab-pane fade ${
              activeTab === "take_action" ? "show active" : ""
            }`}
            id="pills-take_action"
            role="tabpanel"
            aria-labelledby="pills-take_action-tab"
          >
            <div className="h-full">
              {activeTab === "take_action" && <Repotemployeetask/>}
            </div>
          </div>
          <div
            className={`h-full tab-pane fade ${
              activeTab === "archive" ? "show active" : ""
            }`}
            id="pills-archive"
            role="tabpanel"
            aria-labelledby="pills-archive-tab"
          >
            <div className="h-full">
              {activeTab === "archive" && <Repotemployeehours/>}
            </div>
          </div>
          <div
            className={`h-full tab-pane fade ${
              activeTab === "completed" ? "show active" : ""
            }`}
            id="pills-completed"
            role="tabpanel"
            aria-labelledby="pills-completed-tab"
          >
            <div className="h-full">
              {activeTab === "completed" && <Repotemployeecompletedtask/>}
            </div>
          </div>
          <div
            className={`h-full tab-pane fade ${
              activeTab === "details" ? "show active" : ""
            }`}
            id="pills-details"
            role="tabpanel"
            aria-labelledby="pills-details-tab"
          >
            <div className="h-full">
              {activeTab === "details" && <Repotemployeedetailstask/>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report;
